import { Injectable } from '@angular/core';

import { NgxLoggerLevel } from 'ngx-logger';

import { logDB } from '../data/logDB';
import { FileUploadService } from '../_services/FileUpload.service';
import { WSService } from './ws.service';
import { CrossAppMessagingService } from './crossApp-messaging.service';
import { isNativeShell } from '../_helpers/native-shell';
import { safeStringify } from '../_helpers/logSerialize';


@Injectable({
  providedIn: 'root'
})
export class SendLogService {

  constructor(
    ws: WSService,
    private fileUploadService: FileUploadService,
    crossAppMessaging: CrossAppMessagingService,

  ) {
    ws.observe("sendNativeLog").subscribe((msg) => {
      if (isNativeShell()) {
        // Serverski zahtev za log UVEK uključuje i snapshot transactions baze.
        crossAppMessaging?.sendRawMessage({ action: 'sendNativeLog', data: { includeTransactions: true } });
      }
      else {
        this.sendLogFromDB();
      }
    });
  }


  sendLogFromDB() {
    logDB.logs.orderBy('timestamp').toArray().then(
      async logs => {
        // Zapisi se dele PO DANU, po jedan fajl — isto kao native log (Serilog rollira po danu),
        // pa Log inspektor u obe vrste arhive ima listu dana umesto jednog zbirnog fajla.
        const byDay = new Map<string, string[]>();

        for (const log of logs) {
          // Nivo kao ime (WARN/ERROR...) umesto broja — čitljivije i omogućava filter
          // "ERROR" u Log inspektoru; prazan `additional` se izostavlja (ranije je
          // svaka takva linija dobijala "- undefined" rep).
          const level = NgxLoggerLevel[log.level] ?? log.level;
          const additional = log.additional?.length ? ` - ${safeStringify(log.additional)}` : '';
          const line = `${log.timestamp} - ${level} - ${log.message}${additional}`;
          const day = SendLogService.dayKey(log.timestamp);

          const lines = byDay.get(day);
          if (lines) {
            lines.push(line);
          } else {
            byDay.set(day, [line]);
          }
        }

        // Kreiraj ZIP arhivu — jszip se učitava tek pri slanju loga (ne ulazi u inicijalni bundle)
        const jszipModule: any = await import('jszip');
        const JSZip = jszipModule.default ?? jszipModule;
        const zip = new JSZip();

        if (!byDay.size) {
          // Prazna baza — šalje se prazan fajl, da se u arhivi vidi da log nema zapisa.
          byDay.set('', []);
        }

        byDay.forEach((lines, day) => {
          // `logYYYYMMDD.txt` — osam cifara u imenu su ono po čemu Log inspektor prepoznaje dan.
          // Zapis bez upotrebljivog datuma ostaje u zbirnom `log.txt` (kao i do sada).
          zip.file(day ? `log${day}.txt` : 'log.txt', lines.join('\n'), {
            compression: 'DEFLATE'
          });
        });

        // Generiši ZIP fajl kao Blob
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        const zipFile = new File([zipBlob], 'log.zip', { type: 'application/zip' });

        // Pošalji fajl koristeći servis
        this.fileUploadService.uploadLog(zipFile);
      }
    )
  }

  /** ISO timestamp (`2026-09-01T10:11:12.345Z`) → `20260901`; sve ostalo → '' (zbirni fajl). */
  private static dayKey(timestamp: string): string {
    const parts = /^(\d{4})-(\d{2})-(\d{2})/.exec(timestamp || '');
    return parts ? parts[1] + parts[2] + parts[3] : '';
  }
}
